import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { usageFromError } from '@/features/config/pages/Controllers/decoderUsage'
import { getApiErrorMessage } from '@/helpers'
import useTranslation from '@/hooks/useTranslation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { decoderUsageKey } from './useDecoderUsage'

interface DeleteLineUnit {
  interfaceId: number
  id: string
}

const useDeleteLineUnit = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation(
    ({ interfaceId, id }: DeleteLineUnit) =>
      controllerDataConfigApi.delete(String(interfaceId), id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.controller])
        toast.success(t('decoderDeleteSuccess'))
      },
      onError: (error: AxiosError<any>, { interfaceId, id }) => {
        const usage = usageFromError(error)
        if (usage) queryClient.setQueryData(decoderUsageKey(interfaceId, id), usage)
        toast.error(getApiErrorMessage(error, t('decoderDeleteFailed')))
      },
    },
  )
}

export default useDeleteLineUnit
